module.exports = __webpack_public_path__ + "wotcLogo.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wotcLogo.png
// module id = 829
// module chunks = 0